import * as ReactGA from 'react-ga';
import { settings } from './settings';

const trackPage = location => {
  ReactGA.set({ page: location.pathname + location.search });
  ReactGA.pageview(location.pathname + location.search);
};

export const initializeGA = (history, options = {}, anonymize = true) => {
  if(settings.GA_TRACKING_ID) {
    ReactGA.initialize(settings.GA_TRACKING_ID, {
      titleCase: false,
      ...options,
    });
    if(anonymize) {
      ReactGA.set({ anonymizeIp: true });
    }
    trackPage(history.location);
    history.listen(trackPage);
    return history;
  }
};
